<template>
  <div class="layout">
    <Title></Title>
    <div class="container">
      <div class="inner layout_inner">
        <div class="containerSidebar">
          <!-- 左边菜单 -->
          <Sidebar></Sidebar>
        </div>
        <div class="containerright">
              <div class="adress_tit">
                个人中心
              </div>
              <div class="adress_img">

                <img :src="[headers.avatarUrl==''?require('../../assets/home_logo.png'):headers.avatarUrl]" alt="">
                {{headers.name==null?headers.nickName:headers.name}}
              </div>
             <router-view/>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    indexapi
  } from "../../api/http.js"
  import Title from "../../components/title.vue"
  import Sidebar from "./components/sidebar.vue"
  export default {
    name: 'layout',
    components:{
        Title,
        Sidebar
    },
    data(){
      return{
        headers:{}
      }
    },
    async created() {
      const res = await indexapi()
      if (res.data.code === 200) {
        console.log(res.data.data);
        this.headers = res.data.data.user_info

      } else {
        this.headers = []
      }},
  }
</script>

<style lang="less">

.container{
  padding-top: 30px;
  box-sizing: border-box;
  width:100%;
  .layout_inner{
    display: flex;
    justify-content: flex-start;
  }
  .inner{
    width: 1300px;
    margin: 0 auto;
    .containerSidebar{
      width: 180px;
    }
    .containerright{
      width: 1120px;
      .adress_tit {
        width: 100%;
        height: 32px;
        line-height: 32px;
        font-size: 16px;
        color: #292929;
        margin-bottom: 15px;
      }

      .adress_img {
        width: 100%;
        height: 90px;
        background: rgba(234, 248, 255, 0.1);
        border: 1px solid rgba(158, 223, 255, 0.34);
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 50px;
        box-sizing: border-box;
        margin-bottom: 30px;

        img {
          width: 70px;
          height: 70px;
          margin-right: 20px;
          border-radius: 50%;
        }
      }


    }
  }
}


</style>



// WEBPACK FOOTER //
// src/views/layout/layout.vue